import Markdown from 'ai-rendering-library/components/text/Markdown';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { Link } from 'foundations-components/transitional/components/Link';
import styled from 'foundations-theming-specialty/utils';
import { useTracker } from '../hooks/useTracker';
import { copilotV2ExtractTitleAndContentFromSections, extractTitleAndContentFromSections } from '../utils/pluginUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const SandboxRenderWrapper = styled.div.withConfig({
  displayName: "SandboxPlugin__SandboxRenderWrapper",
  componentId: "sc-17faq85-0"
})(["border:", ";border-radius:", ";padding:", ";width:100%;"], ({
  theme
}) => `${theme.borderWidth[100]} solid ${theme.color['border-brand-default']}`, ({
  theme
}) => theme.borderRadius[100], ({
  theme
}) => theme.space[250]);
const SandboxContentWrapper = styled.div.withConfig({
  displayName: "SandboxPlugin__SandboxContentWrapper",
  componentId: "sc-17faq85-1"
})(["border:", ";border-radius:", ";padding:", ";"], ({
  theme
}) => `${theme.borderWidth[100]} solid ${theme.color['text-alert-default']}`, ({
  theme
}) => theme.borderRadius[100], ({
  theme
}) => theme.space[250]);
export const MESSAGE_NOT_FOUND = 'MESSAGE_NOT_FOUND';
const CustomButton = ({
  actionFn,
  infoToPassToApp,
  ChatSpotStyledButtonComponent,
  usageTracker
}) => {
  const handleOnClick = () => {
    return actionFn({
      actionType: 'fill_out_form',
      infoToPassToApp,
      userThread: 'Form Filled out'
    });
  };
  const buttonText = 'Fill out form';
  const {
    copilotToolkitTracker
  } = useTracker(usageTracker);
  return /*#__PURE__*/_jsx(ChatSpotStyledButtonComponent, {
    "data-test-id": "copilot-plugins-sandbox-button",
    onClick: handleOnClick,
    usageTracker: copilotToolkitTracker,
    usageTrackerAppLocationKey: "copilot-plugins",
    eventName: "collaborationModeInteractions",
    children: buttonText
  });
};
const ExtraButtton = ({
  buttonText,
  actionFn,
  ChatSpotStyledButtonComponent,
  usageTracker
}) => {
  const handleOnClick = () => {
    return actionFn({
      actionType: 'fill_out_form',
      infoToPassToApp: `You clicked the extra button - which you named ${buttonText}`,
      userThread: 'Form Filled out'
    });
  };
  const {
    copilotToolkitTracker
  } = useTracker(usageTracker);
  return /*#__PURE__*/_jsx(ChatSpotStyledButtonComponent, {
    "data-test-id": "copilot-plugins-sandbox-button",
    onClick: handleOnClick,
    usageTracker: copilotToolkitTracker,
    usageTrackerAppLocationKey: "copilot-plugins",
    eventName: "collaborationModeInteractions",
    children: buttonText
  });
};
export const SandboxPlugin = {
  gate: 'Copilot:Collaborate',
  intentTypes: ['text_generate'],
  collaborateCopilotMessageTypes: ['THIS_PROP_IS_SILLY'],
  sectionRenderer: (message, __MarkdownComponent, isUngatedForCopilotV2) => {
    const {
      titleText,
      contentText
    } = isUngatedForCopilotV2 ? copilotV2ExtractTitleAndContentFromSections(message) : extractTitleAndContentFromSections(message);
    return /*#__PURE__*/_jsxs(SandboxRenderWrapper, {
      children: [/*#__PURE__*/_jsx(Link, {
        external: true,
        href: "https://git.hubteam.com/HubSpot/copilot-toolkit/blob/681dc98bae40fe715162b3531bdcc6dfa10e6bb1/copilot-plugins/static-1.5724/js/plugins/SandboxPlugin.tsx#L131",
        children: "sectionRenderer (Code)"
      }), /*#__PURE__*/_jsx(HelpIcon, {
        title: "This styling will only show on pages with the Sandbox Plugin. Try navigating somewhere else, and you'll see this text disappear."
      }), /*#__PURE__*/_jsx(Markdown, {
        html: titleText
      }), contentText && /*#__PURE__*/_jsx(SandboxContentWrapper, {
        children: /*#__PURE__*/_jsx(Markdown, {
          html: contentText
        })
      })]
    });
  },
  actionsRenderer: ({
    state,
    message,
    actionFn,
    ChatSpotButtons,
    ChatSpotStyledButtonComponent,
    usageTracker,
    isUngatedForCopilotV2
  }) => {
    const {
      contentText
    } = isUngatedForCopilotV2 ? copilotV2ExtractTitleAndContentFromSections(message) : extractTitleAndContentFromSections(message);
    const buttonText = state && 'buttonText' in state && state.buttonText;
    const showExtraButton = state && 'showExtraButton' in state && state.showExtraButton;
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(HelpIcon, {
        title: /*#__PURE__*/_jsxs("span", {
          children: ["Custom actions are generally used to send actions from copilot to the consuming app. Note: \"Fill out form\" is a custom action, where as \"Refine\" and the copy button are default for the intent type.", ' ', /*#__PURE__*/_jsx(Link, {
            external: true,
            href: "https://git.hubteam.com/HubSpot/copilot-toolkit/blob/681dc98bae40fe715162b3531bdcc6dfa10e6bb1/copilot-plugins/static-1.5724/js/plugins/SandboxPlugin.tsx#L131",
            children: "Code"
          })]
        })
      }), /*#__PURE__*/_jsx(CustomButton, {
        actionFn: actionFn,
        infoToPassToApp: contentText,
        ChatSpotStyledButtonComponent: ChatSpotStyledButtonComponent,
        usageTracker: usageTracker
      }), showExtraButton && buttonText && /*#__PURE__*/_jsx(ExtraButtton, {
        actionFn: actionFn,
        ChatSpotStyledButtonComponent: ChatSpotStyledButtonComponent,
        buttonText: buttonText,
        usageTracker: usageTracker
      }), /*#__PURE__*/_jsx(ChatSpotButtons, {
        text: contentText,
        contentToCopy: contentText
      })]
    });
  }
};